import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { API_ROUTES } from '../../util/route.constants';
import { Appointment, AppointmentResponse, IAppointment } from "../../models/appointment.interface";
import { StartConsulationPatient } from '../../models/patient.interface';
import { IRecommendations } from '../../models/consultation-recommendation.model';


@Injectable({
  providedIn: 'root'
})
export class AppointmentService {

  constructor(
    private readonly http: HttpClient,
  ) { }

  createAppointment(body: Appointment): Observable<Appointment> {
    const url = `${environment.cva_url}${API_ROUTES.APPOINTMENT}`;

    return this.http.post<Appointment>(url, body)
  }

  getAllAppointmentsForPatient(patientId: string, practitionerId: string, start: Date, end: Date): Observable<{ response: AppointmentResponse[] }> {
    const url = `${environment.cva_url}${API_ROUTES.APPOINTMENT}/patient?patientId=${patientId}&practitionerId=${practitionerId}&start=${start.toISOString()}&end=${end.toISOString()}`
    return this.http.get<{ response: AppointmentResponse[] }>(url);
  }

  getAppointmentsByPatientId(patientId: string, start: Date, end: Date, lic: string, practitionerId?: string): Observable<{ response: AppointmentResponse[] }> {
    let url = `${environment.cva_url}${API_ROUTES.APPOINTMENT}?patientId=${patientId}&start=${start.toISOString()}&end=${end.toISOString()}`
    if (lic === "false") {
      url += `&lic=false`
    }
    if (practitionerId) {
      url += `&practitionerId=${practitionerId}`
    }
    return this.http.get<{ response: AppointmentResponse[] }>(url);
  }

  getAppointmentsByPractitionerId(practitionerId: string, start: Date, end: Date, lic: boolean): Observable<{ response: AppointmentResponse[] }> {
    return this.http.get<{ response: AppointmentResponse[] }>(
      `${environment.cva_url}${API_ROUTES.APPOINTMENT}?practitionerId=${practitionerId}&start=${start.toISOString()}&end=${end.toISOString()}&lic=${lic}`
    );
  }

  cancelAppointmentById(uid: string): Observable<{ response: AppointmentResponse }> {
    return this.http.patch<{ response: AppointmentResponse }>(
      `${environment.cva_url}${API_ROUTES.APPOINTMENT}/${uid}/cancel`, {}
    );
  }
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  updateTranscription(appointmentRefId: string, transcription: string, tabsData: any, recommendations?: IRecommendations) {
    return this.http.patch<{ response: boolean }>(
      `${environment.cva_url}${API_ROUTES.APPOINTMENT}/${appointmentRefId}/transcribe`, { transcription, tabsData, recommendations }
    );
  }

  updatePatientConsent(uid: string) {
    return this.http.patch<{ response: boolean }>(
      `${environment.cva_url}${API_ROUTES.APPOINTMENT}/patient/consent`, { uid }
    );
  }

  getAppointmentById(appointmentId: string): Observable<{ response: AppointmentResponse }> {
    return this.http.get<{ response: AppointmentResponse }>(
      `${environment.cva_url}${API_ROUTES.APPOINTMENT}/${appointmentId}`
    );
  }

  deleteTranscription(appointmentRefId: string) {
    return this.http.delete<{ response: boolean }>(`${environment.cva_url}${API_ROUTES.APPOINTMENT}/${appointmentRefId}/transcribe`);
  }

  createAppointmentForPatient(patient: StartConsulationPatient) {
    return this.http.post<{ response: IAppointment }>(`${environment.cva_url}${API_ROUTES.APPOINTMENT}/patient`, patient)
  }
}
